// Lib
import { hot } from 'react-hot-loader/root';
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Router } from '../../node_module_clones/react-router';
import DocumentTitle from 'react-document-title';

import routes from './routes';

// Element connections
import { MeasurementsProvider } from '../components/measurementsStore/MeasurementsProvider';
import { TiptapEditorStoreProvider } from '../components/tiptapEditor/store/TiptapEditorStoreProvider';
import { LiveCollaborationStoreProvider } from '../remoteActivity/liveCollaboration/store/LiveCollaborationStoreProvider';
import { HotTableStoreProvider } from '../element/table/bridge/store/HotTableStoreProvider';
import { RomaRouterBridge } from './RomaRouterBridge';

/**
 * The root component of the application.
 *  - Sets up the Redux Provider (which allows container components to access the store).
 *  - Configures the Router (from React Router).
 *
 * This component requires:
 *  - store (redux store)
 *  - history (the react-router-redux wrapped browserHistory instance)
 */
@hot
class Root extends React.Component {
    render() {
        const { store, history, measurementsStore, tiptapEditorStore, hotTableStore, liveCollaborationStore } =
            this.props;

        return (
            <LiveCollaborationStoreProvider store={liveCollaborationStore}>
                <TiptapEditorStoreProvider store={tiptapEditorStore}>
                    <HotTableStoreProvider store={hotTableStore}>
                        <MeasurementsProvider store={measurementsStore}>
                            <Provider store={store}>
                                <DocumentTitle title="Milanote">
                                    <RomaRouterBridge history={history}>
                                        <Router history={history} routes={routes} store={store} />
                                    </RomaRouterBridge>
                                </DocumentTitle>
                            </Provider>
                        </MeasurementsProvider>
                    </HotTableStoreProvider>
                </TiptapEditorStoreProvider>
            </LiveCollaborationStoreProvider>
        );
    }
}

Root.propTypes = {
    tiptapEditorStore: PropTypes.object.isRequired,
    hotTableStore: PropTypes.object.isRequired,
    measurementsStore: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    liveCollaborationStore: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

export default Root;
